import {Injectable, OnDestroy} from "@angular/core";
import {ModuleConfig, RemoteConfigStore, SOFTLINE_FEATURE_REMOTE_CONFIG} from "@softline/application";
import {filter, map, tap} from "rxjs";
import {Store} from "@softline/core";

@Injectable()
export class RemoteConfigService implements OnDestroy {

    private _config = {
      emballagenEingabeLaden: true,
      vorhandenePalettenAuswaehlbar: false,
      gewichtEditable: true,
      paletteEinzelEingabe: false,
      uploadCommandAnzeigen: false,
      abgeschlosseneArtikelAnzeigen: true,
      eingabeLieferscheinnummerPflicht: false
    };

    get config(): typeof this._config {
        return this._config;
    }

    private subscription = this.store.observe(
        SOFTLINE_FEATURE_REMOTE_CONFIG,
        RemoteConfigStore.getters.data
    ).pipe(
        filter(o => !!o && !!o?.modules),
        map(data => data?.modules?.find(o => o.module === 'llr-bskomm')),
        tap(o => console.log('laden service?: ', o))
    ).subscribe(module => {
        if (!module)
            return;

        this._config = {
          emballagenEingabeLaden: this.getPropertyValue(module, 'EMBALLAGEN_EINGABE') === 'true',
          vorhandenePalettenAuswaehlbar: this.getPropertyValue(module, 'VORHANDENE_PALETTE_AUSWAEHLBAR') === 'true',
          gewichtEditable: this.getPropertyValue(module, 'GEWICHT_EDITABLE') === 'true',
          paletteEinzelEingabe: this.getPropertyValue(module, 'PALETTE_EINZEL_EINGABE') === 'true',
          uploadCommandAnzeigen: this.getPropertyValue(module, '') === 'true',
          abgeschlosseneArtikelAnzeigen: this.getPropertyValue(module, 'ABGESCHLOSSENE_ANZEIGEN') === 'true',
          eingabeLieferscheinnummerPflicht: this.getPropertyValue(module, 'EINGABE_DER_LFNUMMER_PFLICHT') === 'true',
        }
    });

    constructor(private store: Store) {}

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private getPropertyValue(module: ModuleConfig, property: string): string {
        return module?.properties?.find(o => o?.key === property)?.value ?? '';
    }
}
